import { useCallback } from 'react';
import { useTranslation } from '../../i18n/LanguageContext';
import { toDate } from './employeeReportColumns';

/** Texts of Çalışan Raporları (`employeeReports.*`); the Excel file stays Turkish. */
const useEmployeeReportText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`employeeReports.${key}`, vars), [t]);
  const formatDate = useCallback((value) => {
    const date = toDate(value);
    return date ? date.toLocaleDateString(locale) : '';
  }, [locale]);
  return { t, language, locale, label, formatDate };
};

export default useEmployeeReportText;
